import { Injectable } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
import * as jwt_decode from 'jwt-decode';
import * as moment from 'moment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { UserRegisterDto } from './account/account.models';
import { JWTObject } from './auth.models';
import { CookieService } from 'ngx-cookie-service';

export interface AuthenticatedUserResult {
    readonly token: string;
    readonly created: boolean;
}

@Injectable()
export class AuthService {

    API_URL = environment.apiUrl;
    TOKEN = 'token';

    constructor(
        private http: HttpClient,
        private router: Router,
        public jwtHelper: JwtHelper,
        private readonly cookieService: CookieService,
    ) { }

    get token(): string {
        return localStorage.getItem(this.TOKEN);
    }

    get payload(): JWTObject {
        return jwt_decode(this.token);
    }

    get isAuthenticated(): boolean {
        return this.token && !this.jwtHelper.isTokenExpired(this.token);
    }

    private reset(): void {
        localStorage.removeItem(this.TOKEN);
        this.cookieService.delete('access_token');
    }

    logout(): void {
        this.reset();
        this.router.navigateByUrl('/auth/login');
    }

    login(email: string, pass: string) {
        const headers = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };

        const data = {
            email: email,
            password: pass,
        };

        return new Promise((resolve, reject) => {
            this.http.post<AuthenticatedUserResult>(this.API_URL + '/users/login', data, headers).subscribe(
                res => {
                    localStorage.setItem(this.TOKEN, res.token);
                    // const payload = this.payload;
                    if (environment.production) {
                        this.cookieService.set('access_token', res.token, moment().add('day', 14).toDate(), '/', 'la-mira.com', true);
                    } else {
                        this.cookieService.set('access_token', res.token);
                    }
                    this.router.navigateByUrl('/');
                    resolve(null);
                }, (error: any) => {
                    reject(error);
                }
            );
        });

    }

    getAccount() {
        return this.http.get(this.API_URL + '/users/me');
    }

    register(data: UserRegisterDto) {
        return new Promise((resolve, reject) => {
            this.http.post<AuthenticatedUserResult>(this.API_URL + '/users/register', data).subscribe(
                (res: AuthenticatedUserResult) => {
                    const payload: JWTObject = jwt_decode(res.token);
                    // if (environment.production) {
                    //     this.cookieService.set('access_token', res.token, moment().add('day', 14).toDate(), null, '.la-mira.com', true);
                    // } else {
                    //     this.cookieService.set('access_token', res.token);
                    // }
                    resolve(payload);
                }, (error: any) => {
                    reject(error);
                }
            );
        });
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/auth.service.ts